import { useStore } from 'vuex';
import { ref, computed } from 'vue';

export default () => {
  const store = useStore();
  const drawingCursorPosition = ref({ show: false, x: 0, y: 0 });
  const isDrawingMode = computed(() => store.state.app.isDrawingMode);
  const isColorPicking = computed(() => store.state.app.isColorPicking);

  const onCanvasMouseMove = e => {
    if (e.pointer && isDrawingMode.value) {
      const { x, y } = e.pointer;
      // console.log(x, y);
      drawingCursorPosition.value = { show: true, x, y };
    }
  };

  const onMouseOut = () => {
    if (!isDrawingMode.value) return;
    drawingCursorPosition.value.show = false;
  };
  const onMouseOver = e => {
    if (!isDrawingMode.value) return;
    // drawingCursorPosition.value.show = false;
  };

  const onCanvasMouseUp = () => {
    // 取色模式下，canvas上的鼠标up事件，有可能2种情况
    // 1.正常的canvas绘画结束
    // 2.取色
    // 这里处理2这种情况，取色成功逻辑已经前面在src/components/ColorStraw/Index.vue中处理了
    // 这里关闭掉取色模式，并return，不要添加path了
    if (isColorPicking.value) {
      // console.log('drawing end', isColorPicking.value);
      store.commit('app/SET_COLOR_PICKING', false);
      return;
    }
    if (!isDrawingMode.value) return;
    console.log('drawing end');
    store.dispatch('app/addNewBrushPath');
    console.log('addBrushPath');
  };

  return {
    drawingCursorPosition,
    onMouseOut,
    onMouseOver,
    onCanvasMouseMove,
    onCanvasMouseUp,
  };
};
